import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import { useHistory } from "react-router-dom";
import ShareChatApp from "components/ChatApp/ShareChatApp";
import { Button } from "aible";
import moment from "moment";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as tagsReducer from "containers/Tags/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import aibleIconSVG from "images/Aible_Badge-Full-Color.svg";
import IconPoweredCam from "images/powered_camera.svg";
import SearchInputDelayed from "components/Inputs/SearchInput/SearchInputDelayed";
import ChatAppLineage from "components/Lineage/ChatAppLineage";
import UseCaseLineage from "components/Lineage/UseCaseLineage";
import OpenShellCreate from "components/Openshell/OpenShellCreate";
import { AibleAgentTile } from "components/AibleAgent/AgentView";
import styles from "./style.module.css";
import { DEFAULT_TAGS, AGENT_CAPABILITIES } from "containers/Tags/reducer";
import CapabilityItem from "components/Templates/CapabilityItem";
import ChatCapabilityList from "components/ChatGPT/ChatCapabilityList";
import NewFineTunedModelBadge from "components/Templates/NewFineTunedModelBadge";
import { getHasNewFineTunedModel } from "containers/ChatApp/reducer";
import CreateAZTestModal from "components/Templates/CreateAZTestModal";
import TemplateItemTag from "components/Templates/TemplateItemTag";
import BlueprintExport from "components/ChatGPT/BlueprintExport";
import { ImportBlueprint } from "components/ChatGPT/BlueprintCreate";
import { isEnabled } from "@/utils/featureFlags";
import AgentCModal from "components/Templates/AgentC";
import AiqModal from "components/Templates/AiqModal";
import Tooltip from "components/Inputs/Tooltip";
import { Tooltip as AibleTooltip, TooltipTrigger, TooltipContent } from "@/aible/Tooltip/Tooltip";
import AgentPinButton from "components/AibleAgent/AgentPinButton";
import Select from "react-select";
import { SkillsOverview } from "@/components/AibleAgent/AibleAgent";
import { selectOpenClawGatewayUrl, selectOpenClawGatewayToken } from "containers/OpenClaw";
import { setServerUrl, setModel, setApiKey, selectClaudeCodeServerUrl, selectClaudeCodeModel, selectClaudeCodeApiKey, CLAUDE_CODE_MODELS } from "containers/ClaudeCode";
const FILTER_LIST = ["INDUSTRY", "FUNCTION", "TYPE"];
const TemplatesView = ({ history, forceTabView }) => {
    const [tabView, updateTabView] = useState(forceTabView ?? "TEMPLATES");
    const [searchVal, updateSearchVal] = useState("");
    const [selectedItem, updateSelectedItem] = useState(undefined);
    const [showAZTestModal, updateShowAZTestModal] = useState(undefined);
    const dispatch = useDispatch();
    const selectedFolder = useSelector((state) => foldersReducer.getSelectedFolder(state));
    const isBlueprintsLoading = useSelector((state) => globalReducer.getIsBlueprintsLoading(state));
    const isLoading = selectedFolder !== undefined && isBlueprintsLoading;
    const searchFilteredChatApps = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state, searchVal));
    const searchFilteredOpenshell = useSelector((state) => viewReducer.getSearchFilteredOpenshell(state, searchVal));
    const searchFilteredBenchmarks = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state, searchVal, "BENCHMARK"));
    const searchFilteredChatUseCases = useSelector((state) => viewReducer.getSearchFilteredUsecaseTemplates(state, searchVal));
    const searchFilteredItems = [
        ...searchFilteredChatApps,
        ...searchFilteredBenchmarks,
        ...searchFilteredChatUseCases,
        ...(searchFilteredOpenshell ?? [])
    ];
    const filterOptions = useSelector((state) => tagsReducer.getFilterOptions(state));
    // We don't have a templates type :(
    const retTemplates = useSelector((state) => viewReducer.getSearchFilteredMediaTemplates(state, searchVal));
    // console.log("aare templates", [...retTemplates, ...searchFilteredItems]);
    const retSearchFilteredItems = [...searchFilteredItems, ...retTemplates];
    const templatesViewAgents = retSearchFilteredItems.filter((item) => item?.wizard?.isSavedWork !== true);
    // Different check of saved work :|
    // Checking for isSavedWork === false to not break current saved step projects for customers instead of
    // Adding these to above retSearcgFilteredItems.
    const aibleAgents = useSelector((state) => viewReducer.getSearchFilteredAibleAnywhereAgents(state, searchVal));
    const templatesViewAibleAnywhereAgents = aibleAgents.filter((a) => a?.isSavedWork === false);
    // Adding the aibleAnywhereAgents after the chat apps
    const notSavedFilteredItems = [...templatesViewAgents, ...templatesViewAibleAnywhereAgents];
    const [isOpenAgentCModal, setIsOpenAgentCModal] = useState(false);
    const [isOpenAIQModal, setIsOpenAIQModal] = useState(false);
    useEffect(() => {
        updateSearchVal("");
        updateSelectedItem(undefined);
        dispatch(tagsReducer.resetActiveTagFilters());
    }, [tabView, selectedFolder]);
    useEffect(() => {
        dispatch(tagsReducer.resetActiveTagFilters());
        const allItemTags = notSavedFilteredItems
            .flatMap((item) => item?.tags)
            .filter((tag) => tag !== undefined && tag !== null);
        dispatch(tagsReducer.updateAllFilterOptions(allItemTags));
    }, []);
    useEffect(() => {
        if (!isLoading) {
            dispatch(tagsReducer.resetFilterOptions());
            const allItemTags = notSavedFilteredItems
                .flatMap((item) => item?.tags)
                .filter((tag) => tag !== undefined && tag !== null);
            dispatch(tagsReducer.updateAllFilterOptions(allItemTags));
        }
    }, [searchVal, selectedFolder, isLoading]);
    // console.log("All results: ", retSearchFilteredItems);
    const activeFilters = useSelector((state) => tagsReducer.getActiveFilters(state));
    const industryFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "INDUSTRY"));
    const functionFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "FUNCTION"));
    const typeFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "TYPE"));
    const searchText = useSelector((state) => viewReducer.getSearch(state));
    const retResults = notSavedFilteredItems
        .filter((item) => {
        if (activeFilters.length < 1) {
            return true;
        }
        const shouldShowIndustry = item?.tags?.some((tag) => industryFilters?.includes(tag));
        const shouldShowFunction = item?.tags?.some((tag) => functionFilters?.includes(tag));
        const shouldShowType = item?.tags?.some((tag) => typeFilters?.includes(tag));
        if (shouldShowIndustry || shouldShowFunction || shouldShowType) {
            return true;
        }
        return false;
    })
        // Filter out Business Optimize here, if we remove it entirely some other optimize templates don't work...
        .filter((item) => (item?.id === "CHATAIBLE_OPTIMIZE" && item?.name === "Business Optimize" ? false : true));
    // console.log("All type filtered results: ", retResults);
    const savedWork = retSearchFilteredItems?.filter((item) => item?.wizard?.isSavedWork === true && item?.wizard?.isAZTestApp !== true);
    const filteredSavedWork = searchText?.length > 0
        ? savedWork.filter((item) => item?.name?.toLowerCase().includes(searchText.toLowerCase()))
        : savedWork;
    const aaProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const retProjects = Object.keys(aaProjects)
        .filter((a) => a !== "misc" && a !== "generate_agent")
        .filter((a) => aaProjects?.[a]?.isSavedWork !== false)
        .filter((a) => aaProjects?.[a]?.created_date !== undefined || aaProjects?.[a]?.updated_date !== undefined)
        .map((a) => ({ id: a, ...aaProjects[a] }));
    const allRetSorted = [...(filteredSavedWork ?? []), ...(retProjects ?? [])];
    return (React.createElement("div", { className: styles.templatesViewContainer },
        React.createElement(CreateAZTestModal, { showModal: Boolean(showAZTestModal), updateShowModal: () => updateShowAZTestModal(undefined), id: showAZTestModal }),
        tabView === "TEMPLATES" ? (React.createElement(React.Fragment, null,
            React.createElement(TemplatesHeader, { searchVal: searchVal, updateSearchVal: updateSearchVal, totalItems: retResults?.length ?? 0 }),
            React.createElement(TemplatesList, { data: retResults, selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, isOpenAgentCModal: isOpenAgentCModal, setIsOpenAgentCModal: setIsOpenAgentCModal, isOpenAIQModal: isOpenAIQModal, setIsOpenAIQModal: setIsOpenAIQModal }),
            React.createElement(RightPanel, { selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, tabView: tabView, setIsOpenAgentCModal: setIsOpenAgentCModal, setIsOpenAIQModal: setIsOpenAIQModal }))) : tabView === "SAVED_WORK" ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.savedWorkHeader },
                React.createElement("div", { style: { marginRight: "10px" } }, (allRetSorted ?? []).length > 1
                    ? "All " + allRetSorted.length + " Agents"
                    : (allRetSorted ?? []).length + " Agent"),
                React.createElement(ImportBlueprint, null)),
            React.createElement(SavedWorkList, { history: history, data: retSearchFilteredItems, selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, updateShowAZTestModal: updateShowAZTestModal, searchText: searchText }),
            React.createElement(RightPanel, { selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, tabView: tabView }))) : tabView === "LIVE_AGENTS" ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null))));
};
export const TemplatesHeader = ({ searchVal, updateSearchVal, totalItems }) => {
    return (React.createElement("div", { className: styles.templatesHeaderContainer },
        React.createElement("div", { className: styles.templatesTopWrapper },
            React.createElement("div", { className: styles.templatesHeaderTitle }, `${totalItems} agent templates available. Discover the right one for you.`),
            React.createElement("div", { className: styles.templatesSearchWrapper },
                React.createElement(SearchInputDelayed, { value: searchVal, onChange: (value) => updateSearchVal(value), delay: 750, responsive: true, inputClass: styles.templateSearchInput, style: { width: "100%", display: "flex", justifyContent: "center" }, isThinIcon: true, isPurpleFocusOutline: true, autoSelect: true }))),
        React.createElement("div", { className: styles.templatesFiltersWrapper },
            React.createElement(TemplatesFilters, null))));
};
export const TemplatesFilters = () => {
    const filterLabels = FILTER_LIST;
    return (React.createElement("div", { className: styles.templatesFiltersContainer }, filterLabels.map((label) => {
        return React.createElement(TemplatesFilterType, { key: label, type: label });
    })));
};
const TemplatesFilterType = ({ type }) => {
    const dispatch = useDispatch();
    const tagsByType = useSelector((state) => tagsReducer.getTagsByType(state, type));
    const filterOptions = useSelector((state) => tagsReducer.getFilterOptions(state));
    const activeFilters = useSelector((state) => tagsReducer.getActiveFilters(state));
    return (React.createElement("div", { className: styles.templatesFiltersTypeWrapper },
        React.createElement("div", { className: styles.templatesFilterLabel }, type),
        React.createElement("div", { className: styles.filterButtonsContainer }, tagsByType.map((tag, index) => {
            const retImgSrc = tag?.icon;
            // Maybe not the best place to filter out tags by flag, but it's good enough for now
            if (tag?.id === "OPTIMIZE" && !isEnabled("chat-aible-optimize")) {
                return null;
            }
            return (React.createElement("div", { className: styles.filterButtonWrapper, key: index + "__" + tag?.label },
                React.createElement(Tooltip, { trigger: tag?.tooltip === undefined ? ["none"] : ["hover"], overlay: React.createElement("div", { style: tag?.tooltip?.tooltipStyle },
                        tag?.tooltip?.title && React.createElement("div", { style: tag?.tooltip?.titleStyle }, tag.tooltip.title),
                        tag?.tooltip?.text && React.createElement("div", { style: tag?.tooltip?.textStyle }, tag.tooltip.text)) },
                    React.createElement(Button, { onClick: () => {
                            dispatch(tagsReducer.toggleActiveTagFilter(tag?.id));
                        }, style: activeFilters.includes(tag?.id)
                            ? { borderRadius: "16px", background: "#F4F3FF", borderColor: "#5925DC", color: "#5925DC" }
                            : { borderRadius: "16px", color: "#202939" }, isSmall: true, active: activeFilters.includes(tag?.id), disabled: !filterOptions.includes(tag?.id) },
                        retImgSrc && React.createElement("img", { className: styles.filterIcon, src: retImgSrc }),
                        tag?.label))));
        }))));
};
export const TemplatesList = ({ data, selectedItem, updateSelectedItem, isOpenAgentCModal, setIsOpenAgentCModal, isOpenAIQModal, setIsOpenAIQModal }) => {
    const typeFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "TYPE"));
    const pinnedAgents = useSelector((state) => viewReducer.getPinnedAgents(state));
    // These are the priority Top Templates
    const TARGET_IDS = [
        "RETAIL_WHATS_CHANGED_AND_WHY",
        "RETAIL_SALES_DEEP_DIVE",
        "SALES_ANALYTICS",
        "SOCIAL_DETERMINANTS_HEALTH_NLQ"
    ];
    // Ye old terrible method for generating the template order
    // we could have done this through sorting, but that's a hecking lot of work
    // we could have also iterated across and just bubble sorted them to the top
    const targetTemplates = {};
    const remainingTemplates = [];
    data?.forEach((d) => {
        if (TARGET_IDS.includes(d?.id)) {
            targetTemplates[d?.id] = d;
        }
        else {
            remainingTemplates.push(d);
        }
    });
    const topTemplates = TARGET_IDS.map((id) => targetTemplates[id]).filter((t) => Boolean(t));
    let retTemplates = [...topTemplates, ...remainingTemplates];
    retTemplates = retTemplates.sort((a, b) => {
        const aIsLongRunning = a?.tags?.includes("AIBLE_SAFE_CLAW");
        const bIsLongRunning = b?.tags?.includes("AIBLE_SAFE_CLAW");
        if (pinnedAgents?.[b?.id] === true && pinnedAgents?.[a?.id] !== true) {
            return 1;
        }
        else if (pinnedAgents?.[a?.id] === true && pinnedAgents?.[b?.id] !== true) {
            return -1;
        }
        if (aIsLongRunning && bIsLongRunning && b?.id === "CHATAIBLE_AGENT_C") {
            return 1;
        }
        else if (aIsLongRunning && bIsLongRunning && a?.id === "CHATAIBLE_AGENT_C") {
            return -1;
        }
        return 0;
    });
    if (typeFilters?.length) {
        retTemplates = retTemplates
            .sort((a, b) => {
            const aIsUseCase = a?.itemType === "ChatUseCase";
            const bIsUseCase = b?.itemType === "ChatUseCase";
            const aIsBenchmark = a?.itemType === "BENCHMARK";
            const bIsBenchmark = b?.itemType === "BENCHMARK";
            const aIsGenericWhatsChangedAgent = a?.itemType === "ChatApp" && a?.wizard?.chatType === "WHATS_CHANGED" && a?.wizard?.datasetId === undefined;
            const bIsGenericWhatsChangedAgent = b?.itemType === "ChatApp" && b?.wizard?.chatType === "WHATS_CHANGED" && b?.wizard?.datasetId === undefined;
            const aIsLongRunning = a?.tags?.includes("AIBLE_SAFE_CLAW");
            const bIsLongRunning = b?.tags?.includes("AIBLE_SAFE_CLAW");
            if (aIsUseCase && !bIsUseCase) {
                return -1;
            }
            else if (!aIsUseCase && bIsUseCase) {
                return 1;
            }
            else if (aIsUseCase && bIsUseCase) {
                if (a?.id === "CHATAIBLE_DOCUMENT_SUMMARIZATION_SIMPLE") {
                    return 1;
                }
                if (b?.id === "CHATAIBLE_DOCUMENT_SUMMARIZATION_SIMPLE") {
                    return -1;
                }
            }
            if (aIsBenchmark && bIsBenchmark) {
                if (a?.id === "BENCHMARK_TEMPLATE") {
                    return -1;
                }
                else if (b?.id === "BENCHMARK_TEMPLATE") {
                    return 1;
                }
            }
            if (aIsGenericWhatsChangedAgent && !bIsGenericWhatsChangedAgent) {
                return -1;
            }
            else if (!aIsGenericWhatsChangedAgent && bIsGenericWhatsChangedAgent) {
                return 1;
            }
            if (aIsLongRunning && bIsLongRunning && b?.id === "CHATAIBLE_AGENT_C") {
                return 1;
            }
            else if (aIsLongRunning && bIsLongRunning && a?.id === "CHATAIBLE_AGENT_C") {
                return -1;
            }
            return 0;
        })
            .sort((a, b) => {
            if (pinnedAgents?.[b?.id] === true && pinnedAgents?.[a?.id] !== true) {
                return 1;
            }
            else if (pinnedAgents?.[a?.id] === true && pinnedAgents?.[b?.id] !== true) {
                return -1;
            }
            return 0;
        });
    }
    return (React.createElement("div", { className: styles.templatesListContainer },
        React.createElement(AgentCModal, { isNewCreate: true, open: isOpenAgentCModal, onOpenChange: setIsOpenAgentCModal }),
        React.createElement(AiqModal, { open: isOpenAIQModal, onOpenChange: setIsOpenAIQModal }),
        React.createElement("div", { className: styles.templatesListTop }, retTemplates.map((item, index) => {
            if (index < 4) {
                return (React.createElement(TopTemplateItem, { item: item, selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, key: "topItem" + index + "__" + item?.name, showPinButton: true }));
            }
            return React.createElement(React.Fragment, { key: "topItem" + index + "__" + item?.name });
        })),
        React.createElement("div", { className: styles.templatesList }, retTemplates.map((item, index) => {
            if (index >= 4) {
                return (React.createElement(TemplateItem, { item: item, selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, key: index + "__" + item?.name, showPinButton: true }));
            }
            return React.createElement(React.Fragment, { key: index + "__" + item?.name });
        }))));
};
const TopTemplateItem = ({ item, selectedItem, updateSelectedItem, showPinButton }) => {
    const retImgSrc = item?.logoImage?.length > 0
        ? item?.logoImage
        : item?.botImage?.length > 0
            ? item?.botImage
            : item?.id === "Video Analysis" || item?.id === "Image Analysis" || item?.id === "Image Analysis (Reasoning)"
                ? IconPoweredCam
                : item?.wizard?.base64StringBot?.length > 0
                    ? item?.wizard?.base64StringBot
                    : item?.wizard?.base64StringLogo?.length > 0
                        ? item?.wizard?.base64StringLogo
                        : undefined;
    const isSelected = selectedItem?.id === item?.id;
    return (React.createElement("div", { className: styles.topTemplateItem, onClick: () => {
            if (selectedItem?.id === item?.id) {
                updateSelectedItem(undefined);
            }
            else {
                updateSelectedItem(item);
            }
        } },
        React.createElement("div", { className: styles.topTemplateBackgroundWrapper },
            React.createElement("img", { className: styles.topTemplateBackground, src: DEFAULT_TAGS[getType(item) ?? 19]?.background })),
        React.createElement("div", { className: styles.topTemplateItemDetailsWrapper + " " + (isSelected ? styles.isSelected : "") },
            showPinButton && React.createElement(AgentPinButton, { agentId: item?.id }),
            React.createElement("div", { className: !retImgSrc ? styles.topTemplateDefaultIconWrapper : styles.topTemplateIconWrapper, style: item?.logoImage !== undefined || item?.botImage !== undefined
                    ? { background: "transparent", border: "none" }
                    : item?.wizard?.imgStyle },
                React.createElement("img", { className: styles.topTemplateItemIcon, src: retImgSrc ?? aibleIconSVG })),
            React.createElement("div", { className: styles.topTemplateItemLabel }, item?.name),
            React.createElement("div", { className: styles.topTemplateItemDescription }, item?.description ?? "Missing item description"),
            React.createElement("div", { className: styles.topTemplateTags },
                React.createElement(AibleTooltip, null,
                    item?.chatType === "OPENSHELL" || item?.wizard?.chatType === "OPENSHELL" ? (React.createElement(TooltipTrigger, null,
                        React.createElement(TypeTag, { item: item }))) : (React.createElement(TypeTag, { item: item })),
                    React.createElement(TooltipContent, null,
                        React.createElement("strong", null, "Aible Labs Experimental Feature")))))));
};
export const TemplateItem = ({ item, selectedItem, updateSelectedItem, updateShowAZTestModal, openOnClick, showHoverOptions, showUpdatedDate, showAzTests, isSmall, hideDelete, hideShare, openText, dontHighlight, className, reInitFromChat, hideTags = false, useCurrentDatasetSelection, setIsOpenAgentCModal, showPinButton, style }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const retImgSrc = item?.logoImage?.length > 0
        ? item?.logoImage
        : item?.botImage?.length > 0
            ? item?.botImage
            : item?.id === "Video Analysis" || item?.id === "Image Analysis" || item?.id === "Image Analysis (Reasoning)"
                ? IconPoweredCam
                : item?.wizard?.base64StringBot?.length > 0
                    ? item?.wizard?.base64StringBot
                    : item?.wizard?.base64StringLogo?.length > 0
                        ? item?.wizard?.base64StringLogo
                        : undefined;
    const isSelected = selectedItem?.id === item?.id;
    const [showShareModal, setShowShareModal] = useState(false);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const hasNewFineTunedModel = useSelector((state) => getHasNewFineTunedModel(state, item?.id));
    const azTestAppId = useSelector((state) => chatAppReducer.getChatAppAZTest(state, item?.id));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const activeTab = useSelector((state) => nextReducer.getActiveTab(state, nextId));
    const isSavedAgent = item?.wizard?.isSavedWork;
    const handlePublishAgent = (id) => {
        const createOptions = {
            id: id,
            saveToMyWork: false,
            forceToastMessage: "Published to Agent Templates"
        };
        // console.log("Publishing agent: ", id, createOptions);
        dispatch(blueprintReducer.createBlueprintFromBlueprintId(createOptions));
    };
    const handleViewAZtest = (testId) => {
        // console.log("A/Z Test Id: ", testId);
        dispatch(viewReducer.updateDeploymentViewMode("APPS_TESTING"));
        dispatch(viewReducer.updateSelectedAZTestModal(testId));
        dispatch(viewReducer.updateType(viewReducer.VIEW_TYPE.DEPLOYMENTS));
    };
    let retTemplateItemStyle = styles.templateItem;
    if (isSelected && !dontHighlight) {
        retTemplateItemStyle = styles.templateItem + " " + styles.isSelected;
    }
    if (isSmall) {
        retTemplateItemStyle = retTemplateItemStyle + " " + styles.isSmall;
    }
    return (React.createElement("div", { style: style, className: `${retTemplateItemStyle} ${className ?? ""}` },
        showPinButton && React.createElement(AgentPinButton, { agentId: item?.id }),
        React.createElement("div", { className: styles.templateItemDetailsWrapper },
            React.createElement("div", { className: styles.templateItemDetailsContent, onClick: async () => {
                    if (openOnClick) {
                        if (item.itemType === "Agent") {
                            return history.push("/templates/" + item?.id);
                        }
                        setIsTemplateLoading(true);
                        setTimeout(async () => {
                            if (reInitFromChat) {
                                dispatch(chatGPTReducer.resetGPT());
                            }
                            let options = undefined;
                            if (useCurrentDatasetSelection) {
                                if (datasetId && !isNaN(Number(datasetId))) {
                                    if (!options) {
                                        options = {};
                                    }
                                    options.datasetId = Number(datasetId);
                                }
                                if (artifactId && !isNaN(Number(artifactId))) {
                                    if (!options) {
                                        options = {};
                                    }
                                    options.artifactId = Number(artifactId);
                                }
                            }
                            await dispatch(chatGPTReducer.initChatApp(item, undefined, options));
                            await dispatch(nextReducer.init("new", options?.datasetId, undefined, item?.id, undefined, true, item?.id));
                            if (activeTab !== undefined) {
                                dispatch(nextReducer.updateActiveTab(nextId, activeTab));
                            }
                            if (reInitFromChat) {
                                return dispatch(chatGPTReducer.initChatAppHelper(item?.id, undefined, undefined, undefined, options));
                            }
                        }, 5);
                    }
                    else {
                        if (item?.id === "CHATAIBLE_AGENT_C" && setIsOpenAgentCModal !== undefined) {
                            setIsOpenAgentCModal(true);
                        }
                        else if (selectedItem?.id === item?.id) {
                            updateSelectedItem(undefined);
                        }
                        else {
                            if (item?.wizard?.openshellConfig !== undefined && selectedItem !== undefined) {
                                updateSelectedItem(undefined);
                            }
                            updateSelectedItem(item);
                        }
                    }
                } },
                React.createElement("div", { className: styles.topTemplateItemBadge },
                    React.createElement(NewFineTunedModelBadge, { id: item?.id })),
                React.createElement("div", { className: !retImgSrc ? styles.templateDefaultIconWrapper : styles.templateIconWrapper, style: item?.logoImage !== undefined || item?.botImage !== undefined
                        ? { background: "transparent", border: "none" }
                        : item?.wizard?.imgStyle },
                    React.createElement("img", { className: styles.templateItemIcon, src: retImgSrc ?? aibleIconSVG })),
                React.createElement("div", { className: styles.templateItemDetailsContainer },
                    React.createElement("div", { className: styles.templateItemTitleSection },
                        React.createElement("div", { className: styles.templateItemLabel }, item?.name),
                        showUpdatedDate && item?.updated_date && (React.createElement("div", { className: styles.templateItemUpdatedDate }, moment.utc(item?.updated_date).local().fromNow())),
                        showAzTests && azTestAppId && (React.createElement("div", { className: styles.azTestInProgressBadge }, "A/Z Test In Progress"))),
                    !hideTags && (React.createElement("div", { className: styles.templateItemTagsContainer }, item?.tags &&
                        item.tags.map((tagId) => {
                            return React.createElement(TemplateItemTag, { tagId: tagId, key: tagId });
                        }))),
                    React.createElement("div", { className: styles.templateItemDescription }, item?.description ?? "Missing item description"))),
            showHoverOptions && (React.createElement("div", { className: styles.templateHoverOptions },
                isSavedAgent && React.createElement(BlueprintExport, { blueprint: item, label: "Download", style: { marginRight: "10px" } }),
                isSavedAgent && (React.createElement(BlueprintExport, { mode: "clipboard", label: "Copy", blueprint: item, style: { marginRight: "10px" } })),
                isSavedAgent && (React.createElement(Button, { onClick: (e) => {
                        e.stopPropagation();
                        handlePublishAgent(item?.id);
                    }, style: { marginRight: "10px" }, isSmall: true }, "Publish")),
                !hideShare && !isEnabled("spark-agents-templates-view") && !item?.wizard?.isBenchmark && (React.createElement(ShareChatApp, { onClick: (e) => {
                        e.stopPropagation();
                    }, id: item.id, style: { marginRight: "10px" }, showModal: showShareModal, updateShowModal: () => setShowShareModal(true) }, "Share")),
                hasNewFineTunedModel && updateShowAZTestModal && (React.createElement(Button, { onClick: (e) => {
                        e.stopPropagation();
                        updateShowAZTestModal(item.id);
                    }, style: { marginRight: "10px" }, isSmall: true, type: "primary" }, "Test New Intern")),
                showAzTests && azTestAppId && (React.createElement(Button, { onClick: (e) => {
                        e.stopPropagation();
                        handleViewAZtest(azTestAppId);
                    }, style: { marginRight: "10px" }, isSmall: true }, "View A/Z Test")),
                item?.wizard?.isBenchmark && item?.wizard?.datasetId && (React.createElement(Button, { style: { marginRight: "10px" }, onClick: async (e) => {
                        e.stopPropagation();
                        dispatch(nextReducer.openBenchmark(item?.id));
                    }, isSmall: true }, openText ?? "Open Benchmark")),
                item?.wizard?.isChatApp === true && item?.id && !item?.wizard?.isBenchmark && (React.createElement(Button, { style: { marginRight: "10px" }, onClick: (e) => {
                        e.stopPropagation();
                        if (item?.id === "CHATAIBLE_AGENT_C" && setIsOpenAgentCModal !== undefined) {
                            setIsOpenAgentCModal(true);
                        }
                        else if (item.itemType === "Agent") {
                            return history.push("/templates/" + item?.id);
                        }
                        else if (item?.wizard?.isChatApp === true) {
                            return history.push("/chatTemplate/" + item.id);
                        }
                    }, isSmall: true }, openText ?? "Settings")),
                item?.id && !hideDelete && (React.createElement(Button, { style: {}, onClick: async (e) => {
                        e.stopPropagation();
                        const deleteItem = await dispatch(blueprintReducer.handleDelete(item.id));
                        if (deleteItem && selectedItem) {
                            updateSelectedItem(undefined);
                        }
                    }, isSmall: true }, "Delete")))))));
};
export const RightPanel = ({ selectedItem, updateSelectedItem, tabView, rightPanelStyle, setIsOpenAgentCModal, setIsOpenAIQModal, isOpenShell }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isAibleSafeClawAgent = selectedItem?.isAgentC === true;
    const isOpenShellOrigin = selectedItem?.workflowOrigin === "OPENSHELL";
    const isAiqOrigin = selectedItem?.workflowOrigin === "AIQ";
    const isClawAssistant = isAibleSafeClawAgent && selectedItem?.workflowOrigin !== undefined;
    const assistantStepAgentIds = useSelector((state) => isClawAssistant ? aibleAnywhereReducer.getClawTaskStepAgentIdsFromId(state, selectedItem?.id) : []);
    const assistantWorkflowPlans = useSelector((state) => isClawAssistant ? aibleAnywhereReducer.getClawTaskUsedStepWorkflowsFromId(state, selectedItem?.id) : []);
    const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const retImgSrc = selectedItem?.logoImage?.length > 0
        ? selectedItem?.logoImage
        : selectedItem?.botImage?.length > 0
            ? selectedItem?.botImage
            : selectedItem?.id === "Video Analysis" ||
                selectedItem?.id === "Image Analysis" ||
                selectedItem?.id === "Image Analysis (Reasoning)"
                ? IconPoweredCam
                : selectedItem?.wizard?.base64StringBot?.length > 0
                    ? selectedItem?.wizard?.base64StringBot
                    : undefined;
    const handleTryClick = (item) => {
        console.log("handleTryClick", item);
        if (item?.isAgentC && item?.workflowOrigin === "OPENSHELL" && item?.isAssistant) {
            // Copying the opening behavior for assistant agents that publish to main page now
            return dispatch(viewReducer.initOpenAibleClawAgent(item?.id, true));
        }
        if ((item?.id === "CHATAIBLE_AGENT_C" || item?.wizard?.chatGPT?.chatType === "AGENT_C") &&
            setIsOpenAgentCModal !== undefined) {
            dispatch(chatGPTReducer.selectBlueprint(item.id));
            return setIsOpenAgentCModal(true);
        }
        if (item?.id === "OPENSHELL" || item?.id === "CLAUDE_CODE" || item?.wizard?.openshellConfig !== undefined) {
            dispatch(chatGPTReducer.selectBlueprint(item.id));
            return dispatch(chatGPTReducer.initChatApp(item));
        }
        if ((item?.id === "AIQ_DEEP_RESEARCH" || item?.wizard?.chatGPT?.chatType === "AIQ_DEEP_RESEARCH") &&
            setIsOpenAIQModal !== undefined) {
            dispatch(chatGPTReducer.selectBlueprint(item.id));
            return setIsOpenAIQModal(true);
        }
        if (item?.optimizeSetup !== undefined || item?.agentType === "OPTIMIZE") {
            return dispatch(chatGPTReducer.initChatApp(item));
        }
        if (item.itemType === "Agent") {
            return history.push("templates/" + item?.id);
        }
        if (item?.isAibleAgent) {
            // TODO: Chat Template type of view for aible builder with popup.
            // Currently copying the Edit logic from AgentView component.
            const isAibleSafeClawAgent = item?.isAgentC === true;
            const isOpenShellOrigin = item?.workflowOrigin === "OPENSHELL";
            const isAiqOrigin = item?.workflowOrigin === "AIQ";
            if (!isAibleSafeClawAgent) {
                dispatch(viewReducer.updateAgentAutonomyView("LOW"));
                return history.push("agent/" + item?.id + (isOpenShellOrigin || isAiqOrigin ? "/template" : "/new"));
            }
            return history.push("chatTemplate/" + item?.id);
        }
        // if (item.itemType === "ChatApp") {
        //   history.push("chatTemplate/" + item?.id);
        //   return dispatch(initChatApp(item?.id));
        // }
        // history.push("chatTemplate/" + item?.id);
        // dispatch(chatGPTReducer.selectBlueprint(item?.id));
        // return dispatch(chatGPTReducer.handleInit());
        dispatch(globalReducer.updateIsSkipNextInit(undefined));
        dispatch(globalReducer.updateIsSkipChatGPTInit(undefined));
        dispatch(globalReducer.updateIsSkipChatGPTReset(undefined));
        return history.push("chatTemplate/" + item?.id);
    };
    const retDownloads = Math.floor(selectedItem?.ratings / ((selectedItem?.feedbackScore ?? 90) / 100));
    const selectedBlueprint = useSelector((state) => blueprintReducer.getBlueprint(state, selectedItem?.id));
    const isDefaultBlueprint = isNaN(Number(selectedItem?.id));
    const gatewayUrl = useSelector(selectOpenClawGatewayUrl);
    const gatewayToken = useSelector(selectOpenClawGatewayToken);
    const serverUrl = useSelector(selectClaudeCodeServerUrl);
    const model = useSelector(selectClaudeCodeModel);
    const apiKey = useSelector(selectClaudeCodeApiKey);
    const DEFAULT_INSTANCE_OPTION = [
        {
            label: "Brev CPU-only instance with hosted model",
            value: "BREV"
        },
        {
            label: "Everything on this device",
            value: "THIS_DEVICE"
        }
    ];
    const [selectedInstance, setSelectedInstance] = useState("BREV");
    const selectedInstanceOption = DEFAULT_INSTANCE_OPTION.find((o) => o.value === selectedInstance);
    const selectedSandbox = useSelector((state) => chatGPTReducer.getSelectedSandbox(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const reportLabel = useSelector((state) => nextId !== undefined ? nextReducer.getReportLabel(state, nextId) : undefined);
    return (React.createElement("div", { className: isOpenShell
            ? styles.openShellRightPanel
            : !selectedItem
                ? styles.rightPanel + " " + styles.hiddenRightPanel
                : styles.rightPanel, style: rightPanelStyle },
        React.createElement("div", { className: styles.selectedItemHeader },
            React.createElement("div", { className: styles.selectedItemTopDetailsContainer },
                React.createElement("div", { className: !retImgSrc ? styles.selectedItemDefaultIconWrapper : styles.selectedItemIconWrapper, style: selectedItem?.logoImage !== undefined || selectedItem?.botImage !== undefined
                        ? { background: "transparent", border: "none" }
                        : selectedItem?.wizard?.imgStyle
                            ? { ...selectedItem?.wizard?.imgStyle, padding: "5px 10px" }
                            : undefined },
                    React.createElement("img", { className: styles.selectedItemIcon, src: retImgSrc ?? aibleIconSVG })),
                React.createElement("div", null,
                    React.createElement("div", { className: styles.selectedItemTopDetails },
                        React.createElement("div", { className: styles.selectedItemLabel }, (isOpenShell ? (reportLabel ?? selectedItem?.name) : selectedItem?.name) ?? "Missing item Name"),
                        React.createElement("div", { className: styles.selectedItemDescription }, selectedItem?.description ?? selectedItem?.wizard?.description ?? "Missing item description")),
                    selectedSandbox !== undefined && chatType === "OPENSHELL" ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.closePanelButtonWrapper },
                        React.createElement(Button, { onClick: () => {
                                updateSelectedItem(undefined);
                            } }, "Close"))))),
            (selectedItem?.id === "OPENSHELL" || selectedItem?.wizard?.openshellConfig !== undefined) && (React.createElement(OpenShellCreate, { initialConfig: selectedItem?.wizard?.openshellConfig, onLaunched: (res) => {
                    console.log("Launched:", res);
                    // e.g. connect to res.websocket_url with res.token
                } })),
            selectedItem?.id === "CLAUDE_CODE" && (React.createElement("div", { className: "flex flex-col mt-[14px]" },
                React.createElement("div", { className: styles.openClawConfig },
                    React.createElement("div", { className: styles.openClawConfigRow },
                        React.createElement("div", { className: styles.openClawConfigField },
                            React.createElement("label", { className: styles.openClawConfigLabel }, "Server URL"),
                            React.createElement("input", { className: styles.openClawConfigInput, value: serverUrl, onChange: (e) => dispatch(setServerUrl(e.target.value)) })),
                        React.createElement("div", { className: styles.openClawConfigField },
                            React.createElement("label", { className: styles.openClawConfigLabel }, "API Key"),
                            React.createElement("input", { className: styles.openClawConfigInput, value: apiKey, onChange: (e) => dispatch(setApiKey(e.target.value)), placeholder: "sk-ant-..." })),
                        React.createElement("div", { className: styles.openClawConfigField },
                            React.createElement("label", { className: styles.openClawConfigLabel }, "Model"),
                            React.createElement(Select, { value: CLAUDE_CODE_MODELS.find((m) => m.value === model), onChange: (option) => option && dispatch(setModel(option.value)), options: CLAUDE_CODE_MODELS, isSearchable: false })))))),
            React.createElement("div", { className: styles.selectedItemActions },
                selectedItem?.itemType &&
                    (selectedItem?.id !== "OPENSHELL" || selectedItem?.wizard?.openshellConfig !== undefined) && (React.createElement(Button, { onClick: () => handleTryClick(selectedItem), style: { marginRight: "8px", fontSize: "16px", padding: "10px 20px" }, isSmall: true, type: "primary" }, "Try Template")),
                selectedItem &&
                    !isNaN(selectedItem?.id) &&
                    (selectedItem?.chatType === "AGENT_C" || selectedItem?.wizard?.chatGPT?.chatType === "AGENT_C") && (React.createElement(BlueprintExport, { blueprint: selectedItem },
                    React.createElement(Button, { style: { marginRight: "8px", fontSize: "16px", padding: "10px 20px" }, onClick: async () => { } }, "Export Template"))),
                ((selectedItem?.isAibleAgent && selectedItem?.isAibleBuilder) || selectedItem?.isAgentC) && (React.createElement(Button, { onClick: () => handleTryClick(selectedItem), style: { marginRight: "8px", fontSize: "16px", padding: "10px 20px" }, isSmall: true, type: "primary" }, "Try Template")),
                selectedItem && !isDefaultBlueprint && (React.createElement(Button, { style: { fontSize: "16px", padding: "10px 20px" }, onClick: async () => {
                        const unpublishedItem = await dispatch(blueprintReducer.handleDelete(selectedItem?.id));
                        if (unpublishedItem) {
                            updateSelectedItem(undefined);
                        }
                    } }, "Unpublish")))),
        React.createElement("div", { className: styles.rightPanelItemTagsContainer }, selectedItem?.tags && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.rightPanelTagsLabel }, "Tags: "),
            selectedItem.tags.map((tagId) => {
                return React.createElement(TemplateItemTag, { tagId: tagId, rightPanel: true, key: "templateItemTag__" + tagId });
            })))),
        React.createElement("div", { className: styles.itemDetailsList },
            React.createElement("div", { className: styles.itemDetailsTags }),
            selectedItem?.itemType === "Agent" ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.itemCapabilitiesContainer },
                    "Capabilities",
                    React.createElement("div", { className: styles.itemCapabilitiesList },
                        React.createElement(AgentCapabilitiesList, { type: selectedItem?.media, useGuardrails: selectedItem?.isGuardrailsEnabled }))))) : selectedItem?.agentStepsType ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.itemCapabilitiesContainer },
                    "Capabilities",
                    React.createElement("div", { className: styles.itemCapabilitiesList },
                        React.createElement(ChatCapabilityList, { agentStepTypeOverride: selectedItem?.agentStepsType, listOnly: true }))))) : selectedItem?.isAibleAgent && selectedItem?.isAibleBuilder ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.itemCapabilitiesContainer },
                    "Capabilities",
                    React.createElement("div", { className: styles.itemCapabilitiesList },
                        React.createElement(SkillsOverview, { agent: { id: selectedItem?.id, ...selectedItem }, listStepsOnly: true }))))) : selectedItem?.isAgentC &&
                selectedItem?.workflowOrigin !== undefined &&
                assistantWorkflowPlans?.length > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.itemCapabilitiesContainer },
                    "Capabilities",
                    React.createElement("div", { className: styles.itemCapabilitiesList }, assistantWorkflowPlans.map((executionId) => {
                        const stepFlow = selectedItem?.executionWorkflows?.[executionId];
                        if (!stepFlow) {
                            return null;
                        }
                        const updateWorkflow = (workflow) => {
                            const clawAgent = aibleAnywhereProjects[selectedItem?.id];
                            const updatedAgent = {
                                ...clawAgent,
                                executionWorkflows: {
                                    ...(clawAgent?.executionWorkflows ?? {}),
                                    [executionId]: workflow
                                }
                            };
                            return dispatch(aibleAnywhereReducer.updateBase({
                                ...aibleAnywhereProjects,
                                [selectedItem?.id]: updatedAgent
                            }));
                        };
                        return (React.createElement("div", { className: styles.workflowItem },
                            React.createElement("div", { className: "font-bold" }, stepFlow?.name),
                            React.createElement(SkillsOverview, { agent: stepFlow, listStepsOnly: true, updateWorkflowSource: updateWorkflow })));
                    }))))) : selectedItem?.isAgentC &&
                selectedItem?.workflowOrigin !== undefined &&
                assistantStepAgentIds?.length > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.itemCapabilitiesContainer },
                    "Capabilities",
                    React.createElement("div", { className: styles.itemCapabilitiesList }, assistantStepAgentIds.map((stepAgentId) => {
                        const stepAgent = aibleAnywhereProjects[stepAgentId];
                        if (!stepAgent) {
                            return null;
                        }
                        return (React.createElement("div", { className: styles.workflowItem },
                            React.createElement("div", { className: "font-bold" }, stepAgent?.name),
                            React.createElement(SkillsOverview, { agent: stepAgent, listStepsOnly: true })));
                    }))))) : (React.createElement(React.Fragment, null))),
        selectedItem?.itemType === "ChatApp" ? (React.createElement("div", { className: styles.itemLineage },
            React.createElement(ChatAppLineage, { id: selectedItem?.id }))) : selectedItem?.itemType === "ChatUseCase" ? (React.createElement("div", { className: styles.itemLineage },
            React.createElement(UseCaseLineage, { id: selectedItem?.id }))) : selectedItem?.isAibleAgent ? (React.createElement("div", { className: styles.itemLineage },
            React.createElement(ChatAppLineage, { id: selectedItem?.id, workflowOrigin: selectedItem?.workflowOrigin }))) : isClawAssistant ? (React.createElement("div", { className: styles.itemLineage },
            React.createElement(ChatAppLineage, { id: selectedItem?.id, workflowOrigin: selectedItem?.workflowOrigin }))) : null));
};
const TypeTag = ({ item }) => {
    const allTags = useSelector((state) => tagsReducer.getTags(state));
    if (getType(item) === undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.topTemplateTag },
        React.createElement("div", { className: styles.topTemplateTagIconWrapper },
            React.createElement("img", { className: styles.topTemplateTagIcon, src: DEFAULT_TAGS[getType(item) ?? 19]?.icon })),
        React.createElement("div", { className: styles.topTemplateTagLabel }, allTags[getType(item) ?? 19]?.label)));
};
export const AgentCapabilitiesList = ({ type, useGuardrails }) => {
    let retCapabilities = [...(AGENT_CAPABILITIES[type] ?? [])];
    if (useGuardrails) {
        let guardrailsType = "guardrails_local";
        if (type === "video") {
            guardrailsType = "guardrails_gemini";
        }
        retCapabilities.splice(-1, 0, AGENT_CAPABILITIES[guardrailsType]);
    }
    return (React.createElement(React.Fragment, null, retCapabilities.map((capability, index) => {
        return React.createElement(CapabilityItem, { type: capability, index: index, key: capability.label + "___" + index });
    })));
};
const SavedWorkList = ({ history, data, selectedItem, updateSelectedItem, updateShowAZTestModal, searchText }) => {
    const savedWork = data?.filter((item) => item?.wizard?.isSavedWork === true && item?.wizard?.isAZTestApp !== true);
    const filteredSavedWork = searchText?.length > 0
        ? savedWork.filter((item) => item?.name?.toLowerCase().includes(searchText.toLowerCase()))
        : savedWork;
    const aaProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const retProjects = Object.keys(aaProjects)
        .filter((a) => a !== "misc" && a !== "generate_agent")
        .filter((a) => aaProjects?.[a]?.isSavedWork !== false)
        .filter((a) => aaProjects?.[a]?.created_date !== undefined || aaProjects?.[a]?.updated_date !== undefined)
        .map((a) => ({ id: a, ...aaProjects[a] }));
    const pinnedAgents = useSelector((state) => viewReducer.getPinnedAgents(state));
    const allRetSorted = [...(filteredSavedWork ?? []), ...(retProjects ?? [])]
        .sort((a, b) => {
        return moment(b?.updated_date).diff(moment(a?.updated_date));
    })
        .sort((a, b) => {
        if (pinnedAgents?.[b?.id] === true && pinnedAgents?.[a?.id] !== true) {
            return 1;
        }
        else if (pinnedAgents?.[a?.id] === true && pinnedAgents?.[b?.id] !== true) {
            return -1;
        }
        return 0;
    });
    return (React.createElement("div", { className: styles.savedWorkListContainer },
        React.createElement("div", { className: styles.templatesList },
            allRetSorted.map((item, index) => {
                return item?.isAibleBuilder === true ? (React.createElement(AibleAgentTile, { agent: item, history: history, key: index + "__" + item?.name, showPinButton: true })) : (React.createElement(TemplateItem, { item: item, selectedItem: selectedItem, updateSelectedItem: updateSelectedItem, updateShowAZTestModal: updateShowAZTestModal, key: index + "__" + item?.name, openOnClick: true, showHoverOptions: true, showUpdatedDate: true, showAzTests: true, showPinButton: true }));
            }),
            allRetSorted?.length < 1 && (React.createElement("div", { className: styles.emptySavedWorkText }, "You do not have any saved Agents")))));
};
const getType = (item) => {
    if (item?.itemType === "Agent") {
        return 22;
    }
    if (item?.itemType === "BENCHMARK") {
        return "BENCHMARK";
    }
    if (item?.chatType === "WHATS_CHANGED" || item?.wizard?.chatType === "WHATS_CHANGED") {
        return "WHATS_CHANGED";
    }
    if (item?.chatType === "OPTIMIZE") {
        return "OPTIMIZE";
    }
    if (item?.chatType === "AIBLE" ||
        item?.chatType === "CHATAIBLE_ANALYTICS" ||
        item?.wizard?.chatType === "AIBLE" ||
        item?.wizard?.chatType === "CHATAIBLE_ANALYTICS") {
        return 17;
    }
    if (item?.chatType === "SQL" ||
        item?.chatType === "CHATAIBLE_SQL" ||
        item?.wizard?.chatType === "SQL" ||
        item?.wizard?.chatType === "CHATAIBLE_SQL") {
        return 18;
    }
    if (item?.chatType === "DOCUMENT" ||
        item?.chatType === "CHATAIBLE_DOCUMENT_SUMMARIZATION" ||
        item?.wizard?.chatType === "DOCUMENT" ||
        item?.wizard?.chatType === "CHATAIBLE_DOCUMENT_SUMMARIZATION") {
        return 21;
    }
    if (item?.chatType === "CHAT" ||
        item?.chatType === "CHATAIBLE_JUST_CHAT" ||
        item?.chatType === "CHATAIBLE_RAW_CHAT" ||
        item?.chatType === "CHATAIBLE_ASSISTANT") {
        return 19;
    }
    if (item?.chatType === "CHATAIBLE_AGENT_C" ||
        item?.wizard?.chatType === "AGENT_C" ||
        item?.chatType === "AIQ_DEEP_RESEARCH" ||
        item?.wizard?.chatType === "AIQ_DEEP_RESEARCH" ||
        item?.chatType === "OPENSHELL" ||
        item?.wizard?.chatType === "OPENSHELL" ||
        item?.chatType === "CLAUDE_CODE") {
        return "AIBLE_SAFE_CLAW";
    }
    return undefined;
};
export default TemplatesView;
